import { useToast } from '@chakra-ui/react';
import { ErrorMessages } from '~/monolith-api';
import { useLocalization } from '~/framework';

// * @deprecated - Please use the version from ~/pages/_shared, and see ~/pages/Courses for an example of how to model queries and invalidation
export function useApiErrorMessageToast(errorMessages?: ErrorMessages) {
   const toast = useToast();

   const { _js } = useLocalization();

   return {
      handle(error: any) {
         if (error && error.response && error.response.data) {
            const { code, message } = error.response.data;
            if (code && errorMessages && code in errorMessages) {
               toast({
                  title: errorMessages[code],
                  status: 'error',
                  position: 'top',
               });
            } else if (errorMessages?.default) {
               toast({
                  title: errorMessages.default,
                  status: 'error',
                  position: 'top',
               });
            } else if (message) {
               toast({
                  title: _js(message),
                  status: 'error',
                  position: 'top',
               });
            }
         }
      },
   };
}
